import React from 'react';
import { MsalAuthenticationTemplate, UnauthenticatedTemplate } from '@azure/msal-react';
import { InteractionType } from '@azure/msal-browser';
import AuthenticatedApp from './AuthenticatedApp';
import DelayedErrorPage from '@/components/Error/DelayedErrorPage';
import Button from '@/components/Button/Button';
import tokens from '@/core/tokens.json';
import MaintenanceRedirectProvider from '@/core/providers/MaintenanceRedirectProvider';

export default function RootApp() {
  const CTA = () => (
    <Button variant="contained" onClick={() => window.location.reload()}>
      {tokens.TRY}
    </Button>
  );

  return (
    <>
      <MsalAuthenticationTemplate interactionType={InteractionType.Redirect}>
        <MaintenanceRedirectProvider>
          <AuthenticatedApp />
        </MaintenanceRedirectProvider>
      </MsalAuthenticationTemplate>
      <UnauthenticatedTemplate>
        <DelayedErrorPage
          title={tokens['NOT_AUTHORIZED']}
          description={tokens['LOGIN_RETRY']}
          cta={<CTA />}
        />
      </UnauthenticatedTemplate>
    </>
  );
}
